module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/3281c49dd334bb444abbeb75d67dd085.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_4.svg
// module id = A0HV
// module chunks = 0